<template>
  <div :class="{ form: true, view: !editMode }">
    <div class="label">
      <label>{{ listName }} : </label>
    </div>
    <div class="value">
      <span v-if="editMode === false">
        <span v-for="(data, index) in dataList" :key="data.id" class="attributeList">
          {{ getName(data) }}<span v-if="index !== dataList.length - 1">,</span>
        </span>
        <span v-if="dataList.length === 0" class="attributeList">
          /
        </span>
      </span>

      <div v-if="editMode === true">
        <div v-if="listType.multi === false">
          <select @change="singleChange" v-model="singleSelectedData" :text="getName(singleSelectedData)">
            <option v-for="data in fullDataList" :key="data.id" :value="data">
              {{ getName(data) }}
            </option>
          </select>
        </div>

        <div v-if="listType.multi === true">
          <MultiSelect
            ref="multi"
            @input="singleChange"
            :getName="getName"
            v-model="selectedData"
            :dataList="fullDataList"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MultiSelect from "@/components/util/MultiSelect";
import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";

export default {
  name: "DataBox",

  components: { MultiSelect },

  props: {
    profile: {
      type: Object,
      default: null
    },
    editMode: {
      type: Boolean,
      default: false
    },
    dataListIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      selectedData: null,
      singleSelectedData: null
    };
  },

  computed: {
    dataList: function() {
      if (this.dataListIndex <= this.profile.data.length - 1 && this.profile.data[this.dataListIndex].data)
        return this.profile.data[this.dataListIndex].data;
      return [];
    },

    dataListContainer: function() {
      if (this.dataListIndex <= this.profile.data.length - 1 && this.profile.data[this.dataListIndex].data)
        return this.profile.data[this.dataListIndex];
      return [];
    },

    listName: function() {
      return this.listType.name[this.$store.state.lang].name;
    },

    listType: function() {
      return this.$store.state.data.types[this.dataListIndex];
    },

    fullDataList: function() {
      return this.$store.state.data.data[this.dataListIndex];
    }
  },

  watch: {
    profile() {
      this.init();
    }
  },

  mounted: function() {
    this.init();
  },

  methods: {
    init: function() {
      if (this.dataList.length === 0 && this.listType.multi === false) {
        this.dataList.push(this.fullDataList[0]);
        this.selectedData = [];
        this.selectedData.push(this.fullDataList[0]);
        this.singleSelectedData = this.fullDataList[0];
        return;
      }

      this.selectedData = [];

      for (let i = 0; i < this.fullDataList.length; i++) {
        for (let j = 0; j < this.dataList.length; j++) {
          const id = this.dataList[j].id;
          const data = this.fullDataList[i];
          if (data.id === id) this.selectedData.push(data);
        }
      }

      if (this.selectedData.length === 0) this.selectedData = null;
      if (this.listType.multi === false) this.singleSelectedData = this.selectedData[0];
    },

    getName: function(data) {
      if (!data) return "Choisir";
      if (data.ord === 0 && this.listType.multi === false && this.editMode === false) return "/";
      return data.name[this.$store.state.lang].name;
    },

    save: function() {
      this.dataList.splice(0, this.dataList.length);
      if (this.listType.multi === false) this.dataList.push(this.singleSelectedData);
      else if (this.selectedData) {
        for (let i = 0; i < this.selectedData.length; i++) this.dataList.push(this.selectedData[i]);
      }
    },

    close: function() {
      if (this.$refs.multi) this.$refs.multi.isOpen = false;
    },

    singleChange: function() {
      const dataLists = [];
      this.save();
      const container = this.dataListContainer;
      container.className = "profile.data.CProfileDataList";
      dataLists.push(this.dataListContainer);
      idyuJsonRpc("updateDataList", dataLists);
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/css/vars.scss";
@import "@/assets/css/forms.scss";

.form {
  grid-template-columns: min-content auto;
  grid-gap: 0;

  .label {
    width: 220px;
  }
  padding-top: 3px;
  padding-bottom: 3px;
  &.view {
    padding-top: 8px;
    padding-bottom: 8px;
    border-top: $light_border;

    &:last-child {
      border-bottom: $light_border;
    }

    .value {
      font-weight: bold;
      border-left: $light_border;
      padding-left: 10px;
    }

    &:hover {
      background-color: white;
    }
  }
}

@media screen and (max-width: 680px) {
  .form:not(.view) {
    grid-template-columns: auto !important;
    grid-template-rows: auto !important;

    .value {
      grid-column: 1 !important;
    }

    .label {
      padding-left: 3px;
      padding-bottom: 3px;
    }
  }
}

@media screen and (max-width: 550px) {
  .form {
    &.view {
      grid-template-columns: auto !important;
      grid-template-rows: auto !important;

      .value {
        grid-column: 1 !important;
        border-left: none;
        padding-left: 0;
      }

      .label {
        padding-left: 0px;
        padding-bottom: 0px;
      }
    }
  }
}
</style>
